import { useOperatorFilterModel } from '@features/operator/filterByOperator';
import { usePrepaymentFilterModel } from '@features/firstPaymentDefinition/filterByPrepayments';
import { initBackboneConnectionFiltersHotels } from '@features/hotel/filterHotels';
import { watch } from 'vue';
import {
    useState, useActions,
} from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';

export default function () {
    initBackboneConnectionFiltersHotels();
    const {
        setOperatorFilter,
        operatorsFilter,
    } = useOperatorFilterModel();
    const {
        setPrepaymentFilter,
        selectedPrepayments,
    } = usePrepaymentFilterModel();
    const {
        operators: operatorsBackbone,
        prepayments: prepaymentsBackbone,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['operators', 'prepayments']);
    const {
        action_operators: setOperatorsBackbone,
        action_prepayments: setPrepaymentsBackbone,
    } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_operators', 'action_prepayments']);

    watch(operatorsBackbone, (value) => {
        setOperatorFilter(value);
    }, { immediate: true });

    // Наружу (backbone → URL) отдаём фактический выбор пользователя, без канонизации:
    // ссылка вида f_operators=226.299 не должна схлопываться в 226 при инициализации.
    // Канонизация нужна только для отображения одной галочки «Травелата» (takenOperators).
    watch(operatorsFilter, (value) => {
        setOperatorsBackbone(value);
    });

    watch(prepaymentsBackbone, (value) => {
        setPrepaymentFilter(value);
    }, { immediate: true });

    watch(selectedPrepayments, (value) => {
        setPrepaymentsBackbone(value);
    });
}